// extracted by mini-css-extract-plugin
export default {"link":"Links_link__Ldh7M","link_title":"Links_link_title__hnoTj","link_path":"Links_link_path__0QyLb"};